import React, { Component } from 'react';
import Button from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Button';
import { withHousehold } from 'Context/HouseholdContext';
import { NotificationManager } from 'react-notifications';
import { noop } from 'Helpers/PropTypes';
import HeaderFooterModal from 'Components/UI/HeaderFooterModal/HeaderFooterModal';
import Input from 'Components/UI/BehavioralFormElement/Text/ExpandingTextarea';
import PropTypes from 'prop-types';
import withEventTrackingLogEvent from 'EventTracking/withEventTrackingLogEvent';
import { SwaggerlessContext } from 'Context/SwaggerlessContext';

const formTypesMap = () => ({
  recommendation: {
    header: 'Recommendation',
  },
  strategy: {
    header: 'Strategy',
  },
  footnote: {
    header: 'Footnote',
  },
});

class EditNoteModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      content: null,
    };

    this.onChange = this.onChange.bind(this);
    this.closeIfOpen = this.closeIfOpen.bind(this);
    this.handleUpdate = this.handleUpdate.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
  }

  componentDidUpdate(prevProps) {
    this.resetContent(prevProps);
  }

  onChange(key, val) {
    this.setState({ content: val });
  }

  onUpdateFinish() {
    const { type } = this.props;
    const types = formTypesMap();
    this.closeIfOpen();
    NotificationManager.success(`${types[type].header} updated.`);
  }

  onDeleteFinish() {
    const { type } = this.props;
    const types = formTypesMap();
    this.closeIfOpen();
    NotificationManager.success(`${types[type].header} removed.`);
  }

  resetContent(prevProps) {
    const { isOpen } = this.props;
    const { isOpen: wasOpen } = prevProps;
    if (!isOpen && wasOpen) {
      this.setState({ content: null });
    }
  }

  handleUpdate() {
    const {
      updateNote,
      selectedNote,
      onNoteUpdate,
      householdId,
      EventTracking,
    } = this.props;
    const { content } = this.state;
    const { logEvent } = EventTracking;

    const requestBody = {
      type: 'QuestionnaireSectionNote',
      attributes: {
        householdId: householdId.toString(),
        content: content || selectedNote.attributes.content,
        weight: selectedNote.attributes.weight,
      },
    };

    logEvent('Saved an updated Note');

    updateNote(selectedNote.id, requestBody)
      .then(onNoteUpdate)
      .then(this.onUpdateFinish());
  }

  handleDelete() {
    const {
      selectedNote,
      // eslint-disable-next-line react/prop-types
      householdId,
      onNoteDelete,
    } = this.props;
    const { removeQuestionnaireSectionNote } = this.context;
    removeQuestionnaireSectionNote(householdId, selectedNote.id)
      .then(onNoteDelete)
      .then(this.onDeleteFinish());
  }

  closeIfOpen() {
    const { isOpen, onClose } = this.props;
    if (isOpen) {
      onClose();
    }
  }

  renderModalFooter() {
    const { onClose } = this.props;
    return (
      <div>
        <Button
          className="save"
          color="primary"
          variant="contained"
          disableElevation
          onClick={() => this.handleUpdate()}
        >
          Save
        </Button>
        <Button className="delete" onClick={() => this.handleDelete()}>
          Delete
        </Button>
        <Button className="exit" onClick={onClose}>
          Close
        </Button>
      </div>
    );
  }

  render() {
    const {
      type,
      selectedNote: { attributes },
      ...rest
    } = this.props;
    const { content } = this.state;
    const types = formTypesMap();
    const title = `Edit ${types[type].header}`;
    const placeholder = types[type].header;
    const existingContent = attributes ? attributes.content : '';
    return (
      <HeaderFooterModal
        {...rest}
        headerText={title}
        footer={this.renderModalFooter(types)}
        className="edit-note-modal"
        onCtrlEnter={this.handleUpdate}
      >
        <Input
          placeholder={placeholder}
          label={placeholder}
          maxLength={1000}
          name="section-note"
          onChange={this.onChange}
          value={content != null ? content : existingContent}
          onKeyDown={this.onKeyDown}
        />
      </HeaderFooterModal>
    );
  }
}

EditNoteModal.contextType = SwaggerlessContext;

EditNoteModal.propTypes = {
  householdId: PropTypes.number.isRequired,
  type: PropTypes.string.isRequired,
  footnotes: PropTypes.array,
  strategies: PropTypes.array,
  recommendations: PropTypes.array,
  updateNote: PropTypes.func.isRequired,
  selectedNote: PropTypes.object,
  toggle: PropTypes.func,
  onNoteUpdate: PropTypes.func,
  onNoteDelete: PropTypes.func,
  isOpen: PropTypes.bool,
};

EditNoteModal.defaultProps = {
  footnotes: [],
  strategies: [],
  recommendations: [],
  selectedNote: {},
  toggle: noop,
  onNoteUpdate: noop,
  onNoteDelete: noop,
  isOpen: false,
};

const eventTrackingProperties = {
  nodeName: 'Edit Note Modal',
};
export default withEventTrackingLogEvent(eventTrackingProperties, withHousehold(EditNoteModal));
